import React, { Component } from 'react';
import { connect } from 'react-redux';
import { verifyUser } from "./actions";
import {Card, CardBlock, Button} from 'reactstrap';
import { Link } from 'react-router-dom';
import SiteFoot from '../../../../shared/components/footer/index';

class VerifyUser extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick () {
        this.props.params.history.push('/sign-in')
    }

    componentDidMount() {
        document.title = "Verify User";
        const { match: { params } } = this.props.params;
        this.props.verifyUser(params);

    }

    render() {
        return (
            <div className="view sign-in">
                <div className="sign-in__container view-content view-pages view-session d-flex justify-content-center align-items-center flex-column">
                    <Card className="mb-3 form-card main-block main-block--verify">
                        <CardBlock>
                            {
                                this.props.store.verifying ?
                                (<h3>Verifying your email...</h3>) :
                                <div>
                                {
                                    this.props.store.verified ?
                                    (<h4>We have successfully verified your email.</h4>) :
                                    (<h4>
                                        {
                                            (this.props.store.alreadyDeleted) ? this.props.store.alreadyDeleted : "We have failed to verify your email."
                                        }
                                    </h4>)
                                }
                                </div>
                            }
                            <br />
                            {
                                this.props.store.verified ?
                                    (<Button onClick={ this.onClick } color="primary" block size="lg">Sign In</Button>)
                                    :
                                    <Link to="/"><p className="btn-link">Go To Home</p></Link>
                            }
                        </CardBlock>
                    </Card>
                    <SiteFoot className="site-foot"/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        store: state.verifyUser
    }
};

const mapDispatchToProps = dispatch => {
    return {
        verifyUser: (params) => dispatch(verifyUser(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyUser);


// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/VerifyUser/index.js